<template>
  <b-modal
      v-bind="$props"
      :id="id"
      centered
      footer-class="border-0 pt-0"
      hide-header
      no-close-on-backdrop
      no-close-on-esc
  >
    <validation-observer ref="form" tag="div">
      <div class="text-center mb-3">
        <img :src="WarningIcon" alt="" class="d-block mx-auto mb-3" height="40" width="40">
        <h4>{{ rejectConfirmTitle }}</h4>
        <p class="m-0" v-html="rejectConfirmDescription"></p>
      </div>
      <validation-provider
          v-slot="{ validated, errors }"
          :name="lodash.startCase($t('balancing_approvals.modal_messages.reject_reason_label'))"
          rules="required"
          vid="description"
      >
        <b-form-group
            :invalid-feedback="errors[0]"
            :label="`${lodash.startCase($t('balancing_approvals.modal_messages.reject_reason_label'))}*`"
            :state="errors[0] ? false : (validated ? true : null)"
            label-for="balancing-approval-reject-description"
        >
          <b-form-textarea
              id="balancing-approval-reject-description"
              v-model="form.description"
              :placeholder="$t('balancing_approvals.modal_messages.reject_reason_placeholder')"
              :state="errors[0] ? false : (validated ? true : null)"
              rows="4"
          ></b-form-textarea>
        </b-form-group>
      </validation-provider>
      <validation-provider
          v-slot="{ validated, errors }"
          :name="lodash.startCase($t('balancing_approvals.modal_messages.attachment_label'))"
          rules="mimes:image/jpeg,image/png,application/pdf"
          vid="file"
      >
        <b-form-group
            :invalid-feedback="errors[0]"
            :label="lodash.startCase($t('balancing_approvals.modal_messages.attachment_label'))"
            :state="errors[0] ? false : (validated ? true : null)"
            class="mt-3"
            label-for="balancing-approval-reject-attachment"
        >
          <b-form-file
              id="balancing-approval-reject-attachment"
              v-model="form.file"
              :drop-placeholder="$t('balancing_approvals.modal_messages.attachment_drop_placeholder')"
              :placeholder="$t('balancing_approvals.modal_messages.attachment_placeholder')"
              :state="errors[0] ? false : (validated ? true : null)"
              accept="image/jpeg,image/png,application/pdf"
          />
        </b-form-group>
      </validation-provider>
    </validation-observer>
    <template #modal-footer>
      <div class="d-flex justify-content-end gap-2 w-100">
        <b-button
            block
            variant="light"
            @click="handleCancel"
        >
          <b>{{ lodash.startCase($t('balancing_approvals.buttons.cancel')) }}</b>
        </b-button>
        <b-button
            block
            class="m-0"
            variant="danger"
            @click="handleConfirm"
        >
          <b>{{ lodash.startCase($t('balancing_approvals.buttons.reject')) }}</b>
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import ConfirmationModal from '@/components/modals/confirmation-modal.vue'
import WarningIcon from '@/assets/icons/WarningIcon.svg'

export default {
  name: 'balancing-approval-reject-confirmation',
  extends: ConfirmationModal,
  props: {
    id: {default: 'balancing-approval-reject-confirmation-modal'},
    hideHeader: {default: true},
    title: {default: ''},
  },
  data() {
    return {
      WarningIcon,
      options: {
        message: null,
        modelId: null,
      },
      resolvePromise: null,
      form: {
        description: '',
        file: null,
      },
    };
  },
  computed: {
    rejectConfirmTitle() {
      return this.options.title || `${this.$t('balancing_approvals.modal_messages.confirm_reject_title')}?`
    },
    rejectConfirmDescription() {
      if (this.options.message) {
        return this.options.message
      }

      const description = this.$t('balancing_approvals.modal_messages.{something}_confirm_reject_description')
      const safeSomething = this.lodash.escape(this.options.modelId || '')

      return description.replace('{something}', `<strong>${safeSomething}</strong>`)
    },
  },
  methods: {
    show(options = {}) {
      return new Promise((resolve) => {
        this.options = {
          message: null,
          modelId: null,
          ...options,
        }
        this.form.description = ''
        this.form.file = null
        this.$bvModal.show(this.id)

        this.resolvePromise = resolve

        this.$nextTick(() => {
          this.$refs.form?.reset()
        })
      });
    },
    async handleConfirm() {
      if (!this.$refs.form) {
        return
      }

      const isValid = await this.$refs.form.validate()
      if (!isValid) {
        return
      }

      if (this.resolvePromise) {
        this.resolvePromise({
          description: this.form.description.trim(),
          file: this.form.file,
        })
      }
      this.hide()
    },
    handleCancel() {
      if (this.resolvePromise) {
        this.resolvePromise(false)
      }
      this.hide()
    },
    hide() {
      this.$bvModal.hide(this.id)
    },
  }
}
</script>

<style scoped lang="scss">
::v-deep {
  .modal-body {
    color: var(--neutral-gray-800, #454646);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }

  .modal-footer {
    border: none;
  }
}
</style>
